
import { defineComponent  } from 'vue'
import RenewalService from '@/views/dashboard/service/subscribe-details/_components/renewal-service.vue'

export default defineComponent({
  components: { RenewalService },

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
  },

  setup (props, context) {
    function handleClose () {
      context.emit('update:modelValue', false)
    }

    return {
      handleClose
    }
  }
})
